import { supabase } from './supabaseClient';

/** アカウントを完全に削除する（設定画面「アカウントを削除する」から） */
export async function deleteAccount() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('ログインが必要です');

  const res = await fetch('/api/delete-account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `削除に失敗しました（${res.status}）`);
  }
}
